import React from "react";
import WhyChooseUsImage from "../assets/img/Whychooseus3.jpg";

const ChooseUs = () => {
  return (
    <>
      <section id="about" className="about section">
        <div className="content" style={{ backgroundColor: "#d4561a" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <img
                  src={WhyChooseUsImage}
                  alt="Image"
                  className="img-fluid img-overlap mt-3"
                  data-aos="zoom-out"
                />
              </div>
              <div
                className="col-lg-5 ml-auto"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h1 className="content-subtitle" style={{ color: "black" }}>
                  Why Choose Us
                </h1>
                <h3 className="content-title mb-4" style={{ color: "black" }}>
                  Expertise & Innovations in the{" "}
                  <strong>Pulses Industry</strong>
                </h3>
                <p style={{ color: "black" }}>
                  The Indo Pulses Development Association (IPDA) is India’s
                  first Commodity Stewardship Council dedicated to transforming
                  the pulses sector through a collaborative, inclusive, and
                  innovation-led approach. Backed by the Government of
                  Maharashtra under the SMART Project, IPDA works at the
                  intersection of policy, practice, and partnership—bringing
                  together farmers, processors, researchers, and industry
                  leaders to strengthen seed systems, promote value addition,
                  and ensure sustainable returns across the value chain.
                </p>
                <p style={{ color: "black" }}>
                  With a focus on evidence-based advocacy, grassroots
                  engagement, and sectoral capacity building. IPDA is a trusted
                  platform for driving impact at scale in India’s pulses
                  ecosystem.
                </p>

                {/* <div className="row my-5" style={{ color: "black" }}>
                  <div className="col-lg-12 d-flex align-items-start mb-4">
                    <i className="bi bi-people-fill me-4 display-6"></i>
                    <div>
                      <h4 className="m-0 h5 ">
                        Strong Industry Collaborations
                      </h4>
                      <p style={{ color: "black" }}>
                        Partnerships with SOPA, Kirti Oil Industries, Vijay Soya
                        Agro, and more.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12 d-flex align-items-start mb-4">
                    <i className="bi bi-lightbulb-fill me-4 display-6"></i>
                    <div>
                      <h4 className="m-0 h5 ">Innovation & Research</h4>
                      <p style={{ color: "black" }}>
                        Collaboration with ICAR – IISR and Agribazaar to drive
                        advancements.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12 d-flex align-items-start">
                    <i className="bi bi-globe2 me-4 display-6"></i>
                    <div>
                      <h4 className="m-0 h5 ">
                        Sustainable & Competitive Growth
                      </h4>
                      <p style={{ color: "black" }}>
                        Creating a robust soybean value chain with sustainable
                        strategies.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12 d-flex align-items-start">
                    <i className="bi bi-megaphone-fill me-4 display-6"></i>
                    <div>
                      <h4 className="m-0 h5 ">
                        Policy Advocacy & Capacity Building
                      </h4>
                      <p style={{ color: "black" }}>
                        Uniting stakeholders to define long-term vision and
                        address policy gaps.
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChooseUs;
